//
// --- Types ---

export type PermissionTypeKey = keyof typeof PERMISSION;
export type PermissionType = typeof PERMISSION[PermissionTypeKey];

export type PermissionGrantScopeKey = keyof typeof PERMISSION_GRANT_SCOPE;
export type PermissionGrantScopeType = typeof PERMISSION_GRANT_SCOPE[PermissionGrantScopeKey];

export type ProductItemEntityNameKeyType = keyof typeof PRODUCT_ITEM_ENTITY_NAME;
export type ProductItemEntityNameType = typeof PRODUCT_ITEM_ENTITY_NAME[ProductItemEntityNameKeyType];

export type EIPProductKey = keyof typeof PRODUCT;
export type EIPProductIdType = typeof PRODUCT[EIPProductKey];

export type ProductRoleTypeKey = keyof typeof PRODUCT_ROLE;
export type ProductRoleType = typeof PRODUCT_ROLE[ProductRoleTypeKey];

export type ProductTypeKey = keyof typeof PRODUCT_TYPE;
export type ProductType = typeof PRODUCT_TYPE[ProductTypeKey];

export type ScreenDescriptionTypeKey = keyof typeof SCREEN_DESCRIPTION;
export type ScreenDescriptionType = typeof SCREEN_DESCRIPTION[ScreenDescriptionTypeKey];

//
// --- Supplier Search App "Product" ---

/**
 * Constants for the current product this app is being used in. Product in this
 * context is meant to reference PowerAdvocate products like Sourcing Intelligence,
 * Supplier Intelligence, Contract Intelligence, Market Intelligence etc.
 */
export const PRODUCT_TYPE = {
  CONTRACT: 'contract',
  MARKET: 'market',
  PORTAL: 'portal',
  SOURCING: 'sourcing'
} as const;

//
// --- EIP Product ---

export const PRODUCT = {
  SOURCING_INTELLIGENCE: 1000,
  MARKET_INTELLIGENCE: 1003,
  CONTRACT_INTELLIGENCE: 1004,
  SUPPLIER_INTELLIGENCE: 1005
} as const;

//
// --- EIP Product Roles ---

export const PRODUCT_ROLE = {
  MARKET_CLIENT_ADMIN: 1018,
  MARKET_PLATFORM_ADMIN: 1017,
  MARKET_STANDARD: 1019,
  SOURCING_PLATFORM_ADMIN: 1000
} as const;

//
// --- Product Permissions ---

export const SCREEN_DESCRIPTION = {
  EDIT_PORTAL: 6011, // screen permission for editing portals
  SETUP_SUPPLIER_BID_EVENT: 1092, // supplier setup screen for bid events
  SETUP_SUPPLIER_PORTAL: 6001, // supplier setup screen for portals
  VIEW_SUPPLIER: 6000
} as const;

export const PERMISSION = {
  GRANT_CREATE: 1000,
  GRANT_DELETE: 1003,
  GRANT_EDIT: 1002,
  GRANT_VIEW: 1001
} as const;

// Not really sure if this is named correctly, but these values are used in permission maps
// returned for discovery lists and this seems like the best name based on EIP code
export const PERMISSION_GRANT_SCOPE = {
  ALL: 1000,
  COMPANY_OWNER: 1002,
  OWNER: 1001
} as const;

// --- Domain Object Descriptions ---

export const DOMAIN_OBJECT_DESCRIPTION = {
  BID_EVENT: 1000,
  PORTAL: 6000
};

/**
 * "Entity Name" is a concept internal to this app. Its a string of text that describes the
 * type of item being referenced for an EIP product. This is used for entities like
 *  "bid events" in sourcing or "portals" in supplier intelligence
 */
export const PRODUCT_ITEM_ENTITY_NAME = {
  BID_EVENT: 'Bid Event',
  PORTAL: 'Portal'
} as const;
